

// import React, { useState, useEffect, useRef } from 'react';

// import { FaEdit } from 'react-icons/fa';
// import { MessageSquare, Users, Send, X, RefreshCw } from 'lucide-react';

// // Theme configuration fallback block based on your design sample aesthetics
// const theme = {
//   primary: '#4f46e5',
//   primaryLight: 'rgba(79, 70, 229, 0.1)',
//   primaryBorder: 'rgba(79, 70, 229, 0.15)',
//   primaryForeground: '#ffffff',
//   card: '#ffffff',
//   border: '#e5e7eb',
//   mutedBg: '#f9fafb',
//   textForeground: '#111827',
//   textMuted: '#6b7280'
// };

// const SendMessaging = () => {
//   // 1. Template States
//   const [templateList, setTemplateList] = useState([]);
//   const [selectedTemplateName, setSelectedTemplateName] = useState('');
//   const [selectedTemplateDetails, setSelectedTemplateDetails] = useState(null);

//   // 2. Data States dependent on Template
//   const [groupName, setGroupName] = useState('');
//   const [subgroupName, setSubgroupName] = useState('');
//   const [groupOptions, setGroupOptions] = useState([]);
//   const [groupedContacts, setGroupedContacts] = useState({});
//   const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);


//   // 3. Selection & Search States
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedContactIds, setSelectedContactIds] = useState([]);
//   const [isConfirmed, setIsConfirmed] = useState(false); // 👈 ADD THIS LINE

//   const [greetingMessage, setGreetingMessage] = useState('');
//   const [sendMessage, setSendMessage] = useState(null);
//   const [waId, setWaId] = useState(null);
//   const [isSending, setIsSending] = useState(false);
//   const [selectedTableName, setSelectedTableName] = useState('');

//   const [sentCount, setSentCount] = useState(0);
//   const [progress, setProgress] = useState(0);
//   const [successMessage, setSuccessMessage] = useState("");



//   const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

//   useEffect(() => {
//     fetchGreetingMessage();
//   }, []);

//   useEffect(() => {
//     if (selectedTableName) {
//       fetchContacts();
//     }
//   }, [selectedTableName]);

//   useEffect(() => {
//     if (groupName && groupedContacts[groupName]) {
//       const subgroup = subgroupName || 'No Subgroup';
//       const contacts = groupedContacts[groupName][subgroup] || [];
//       setSelectedGroupContacts(contacts);
//       // setSelectedContactIds(contacts.map(c => c.id));
//       // Keep only the members that were already selected
//       setSelectedContactIds(prev =>
//         prev.filter(id => contacts.some(contact => contact.id === id))
//       );
//     } else {
//       setSelectedGroupContacts([]);
//       setSelectedContactIds([]);
//     }
//   }, [groupName, subgroupName, groupedContacts]);

//   const fetchGreetingMessage = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem('user'));
//       const wa_id = user?.wa_id;
//       const p_id = user?.p_id;
//       setWaId(wa_id);
//       if (!wa_id || !p_id) {
//         setGreetingMessage(null);
//         setSendMessage(null);
//         setTemplateList([]);
//         return;
//       }
//       const response = await fetch('https://botapi.emedha.in/pages/api/getConfig');
//       const data = await response.json();
//       if (data.success && Array.isArray(data.data)) {
//         const userMessages = data.data.filter(item => item.wa_id === wa_id && item.p_id === p_id);
//         if (userMessages.length > 0) {
//           setGreetingMessage(userMessages[0]);
//           setSendMessage(userMessages[1] || null);

//           // Map template objects matching API configurations explicitly
//           const templates = userMessages
//             .filter(item => item.template_name)
//             .map(item => ({
//               id: String(item.id), // Ensure it captures the "109" primary database key string safely
//               name: item.template_name,
//               message: item.message || '',
//               header_image: item.header_image,
//               header_type: item.header_type || 'image',
//               table_name: item.table_name,
//             }));
//           setTemplateList(templates);
//         } else {
//           resetAllTemplateDependentStates();
//         }
//       } else {
//         resetAllTemplateDependentStates();
//       }
//     } catch (err) {
//       console.error('Error fetching greeting message:', err);
//       resetAllTemplateDependentStates();
//     }
//   };

//   const resetAllTemplateDependentStates = () => {
//     setSelectedTemplateName('');
//     setSelectedTemplateDetails(null);
//     setSelectedTableName('');
//     setGroupName('');
//     setSubgroupName('');
//     setGroupOptions([]);
//     setGroupedContacts({});
//     setSelectedGroupContacts([]);
//     setSearchTerm('');
//     setSelectedContactIds([]);
//     setIsConfirmed(false);
//   };


//   const handleTemplateChange = async (e) => {
//     const templateName = e.target.value;
//     setSelectedTemplateName(templateName);
//     setGroupName('');
//     setSubgroupName('');
//     setGroupOptions([]);
//     setGroupedContacts({});
//     setSelectedGroupContacts([]);
//     setSearchTerm('');
//     setSelectedContactIds([]);

//     if (!templateName) {
//       setSelectedTemplateDetails(null);
//       setSelectedTableName('');
//       return;
//     }

//     // 1. Capture local structural configurations safely
//     const selected = templateList.find(t => t.name === templateName);
//     let localHeaderComponent = null;
//     let localBodyText = ' ';
//     let localId = '';

//     if (selected) {
//       setSelectedTableName(selected.table_name || '');
//       localId = selected.id || greetingMessage?.id; // 🌟 FALLBACK: If selected mapping failed, grab it from base greetingMessage state
//       localBodyText = selected.message || ' ';

//       localHeaderComponent = selected.header_type === 'video'
//         ? { type: 'HEADER', format: 'VIDEO', example: { header_handle: [selected.header_video] } }
//         : { type: 'HEADER', format: 'IMAGE', example: { header_handle: [selected.header_image] } };
//     } else if (greetingMessage) {
//       // Emergency absolute fallback directly from base config payload row context data
//       localId = greetingMessage.id;
//       setSelectedTableName(greetingMessage.table_name || '');
//     }

//     try {
//       // 2. Fetch the approved layout elements 
//       const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateInfo.php?name=${templateName}&wid=${waId}`);
//       const resData = await response.json();

//       if (resData && resData.data && resData.data.length > 0) {
//         const officialTemplate = resData.data[0];
//         const officialBodyComponent = officialTemplate.components?.find(c => c.type === 'BODY') || { type: 'BODY', text: localBodyText };

//         // 3. Bind absolute verified DB Context values
//         setSelectedTemplateDetails({
//           id: localId, // This passes "109" upstream to handleFileChange context explicitly!
//           whatsapp_meta_id: officialTemplate.id,
//           name: templateName,
//           components: [
//             localHeaderComponent,
//             officialBodyComponent
//           ].filter(Boolean)
//         });

//       } else {
//         setSelectedTemplateDetails({
//           id: localId,
//           name: templateName,
//           components: [localHeaderComponent, { type: 'BODY', text: localBodyText }].filter(Boolean),
//         });
//       }
//     } catch (err) {
//       console.error('Error merging official body layout:', err);
//       setSelectedTemplateDetails({
//         id: localId,
//         name: templateName,
//         components: [localHeaderComponent, { type: 'BODY', text: localBodyText }].filter(Boolean),
//       });
//     }
//   };











//   const fetchContacts = async () => {
//     try {
//       const user = JSON.parse(sessionStorage.getItem('user'));
//       if (!user || !user.id || !selectedTableName) return;

//       const queryParams = new URLSearchParams();
//       queryParams.append('user_id', user.id);
//       queryParams.append('table_name', selectedTableName);

//       const response = await fetch(`https://botapi.emedha.in/pages/api/api/contacts/user?${queryParams.toString()}`);
//       if (!response.ok) throw new Error('Failed to fetch contacts');

//       const data = await response.json();

//       const groupedData = data.contacts.reduce((acc, contact) => {
//         const group = contact.group_name || 'No Group';
//         const subgroup = contact.subgroup_name || 'No Subgroup';
//         if (!acc[group]) acc[group] = {};
//         if (!acc[group][subgroup]) acc[group][subgroup] = [];
//         acc[group][subgroup].push({
//           ...contact,
//           group_id: contact.group_id,
//           subgroup_id: contact.subgroup_id,
//         });
//         return acc;
//       }, {});

//       setGroupedContacts(groupedData);
//       setGroupOptions(Object.keys(groupedData));
//     } catch (err) {
//       console.error('Error fetching contacts:', err);
//     }
//   };


//   const handleGroupChange = (e) => {
//     setGroupName(e.target.value);
//     setSubgroupName('');
//     setSelectedGroupContacts([]);
//     setSelectedContactIds([]);
//     setSearchTerm('');
//     const contacts =
//       groupedContacts[e.target.value]?.["No Subgroup"] || [];

//     if (contacts.length > 0) {

//       const ids = contacts.map(c => c.id);

//       setSelectedGroupContacts(contacts);

//       setSelectedContactIds(ids);

//       updateSelectedMembersFlag(ids);

//     }
//   };


//   const handleSubgroupChange = (e) => {
//     const subgroup = e.target.value;
//     setSubgroupName(subgroup);
//     const selectedContacts = groupedContacts[groupName][subgroup || 'No Subgroup'] || [];
//     setSelectedGroupContacts(selectedContacts);
//     // setSelectedContactIds(selectedContacts.map(c => c.id));
//     const ids = selectedContacts.map(c => c.id);

//     setSelectedContactIds(ids);

//     updateSelectedMembersFlag(ids);
//     setSearchTerm('');
//   };

//   const handleContactCheckboxChange = (contactId) => {
//     if (selectedContactIds.includes(contactId)) {
//       setSelectedContactIds(selectedContactIds.filter(id => id !== contactId));
//     } else {
//       setSelectedContactIds([...selectedContactIds, contactId]);
//     }
//   };

//   // Remove single contact via the cross button click inside the dynamic view grid
//   const handleRemoveIndividualContact = (contactId) => {
//     setSelectedContactIds(selectedContactIds.filter(id => id !== contactId));
//   };

//   const handleSelectAll = () => {
//     const filteredIds = filteredContacts.map(c => c.id);
//     const newSelection = Array.from(new Set([...selectedContactIds, ...filteredIds]));
//     setSelectedContactIds(newSelection);
//   };

//   const handleDeselectAll = () => {
//     const filteredIds = filteredContacts.map(c => c.id);
//     const newSelection = selectedContactIds.filter(id => !filteredIds.includes(id));
//     setSelectedContactIds(newSelection);
//   };


//   const handleResetFlag = async (flagType) => {
//     if (groupName && groupedContacts[groupName]) {

//       const contactIds = selectedContactIds.filter(id => id);
//       const user = JSON.parse(sessionStorage.getItem('user'));
//       const userId = user?.id;

//       if (!userId || !selectedTableName) {
//         alert("User session or template configuration dataset table not found.");
//         return;
//       }

//       if (contactIds.length === 0) {
//         alert("Please select at least one member.");
//         return;
//       }

//       try {
//         const response = await fetch("https://botapi.emedha.in/pages/api/reset-flag",
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               tableName: selectedTableName,
//               groupName,
//               subgroupName: subgroupName || "",
//               contactIds,
//               userId,
//               flag: flagType, // <-- IMPORTANT
//             }),
//           }
//         );

//         const data = await response.json();

//         if (data.success) {

//           setIsConfirmed(flagType === "confirm");

//           await fetchContacts();

//         } else {
//           alert(data.error);
//         }

//       } catch (err) {
//         console.error(err);
//       }
//     }
//   };


//   const updateSelectedMembersFlag = async (contactIds) => {

//     const user = JSON.parse(sessionStorage.getItem("user"));
//     const userId = user?.id;

//     if (!userId || !selectedTableName || contactIds.length === 0) {
//       return;
//     }

//     try {

//       const response = await fetch(
//         "https://botapi.emedha.in/pages/api/select-members-flag",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             tableName: selectedTableName,
//             groupName,
//             subgroupName: subgroupName || "",
//             contactIds,
//             userId,
//           }),
//         }
//       );

//       const data = await response.json();

//       if (!data.success) {
//         console.error(data.error);
//       }

//     } catch (err) {
//       console.error(err);
//     }

//   };

//   const handleSendGreeting = async () => {
//     setIsSending(true);
//     setSuccessMessage("");
//     setSentCount(0);
//     setProgress(0);
//     const contactsToProcess = selectedGroupContacts.filter(contact =>
//       selectedContactIds.includes(contact.id)
//     );

//     if (contactsToProcess.length === 0) {
//       alert('Please select at least one checked member from the list to send messaging.');
//       setIsSending(false);
//       return;
//     }

//     const contactsToSendGreeting = contactsToProcess.filter(contact => contact.flag !== 1);
//     if (contactsToSendGreeting.length === 0) {
//       alert('All targeted contacts have flag set to 1. Cannot send greetings! Please click on Reset button.');
//       setIsSending(false);
//       return;
//     }

//     if (!selectedTemplateDetails?.name) {
//       alert('Template not selected.');
//       setIsSending(false);
//       return;
//     }

//     for (const contact of contactsToSendGreeting) {
//       const payload = {
//         groupId: contact.group_id?.toString(),
//         subGroupId: contact.subgroup_id?.toString(),
//         wid: waId,
//         tempname: selectedTemplateDetails.name
//       };
//       try {
//         const response = await fetch('https://emedha.com/echatbot/enotifier/dtemplate.php', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(payload),
//         });
//         await response.json();
//         setSentCount(prev => {
//           const current = prev + 1;
//           setProgress(
//             Math.round((current / contactsToSendGreeting.length) * 100)
//           );
//           return current;
//         });
//       } catch (error) {
//         console.error(`❌ Error sending payload for ${contact.name}:`, error);
//       }
//     }

//     // setIsSending(false);
//     // alert('Messages sent safely to selected target users!');
//     setIsSending(false);

//     setSuccessMessage(
//       `✅ Successfully finished! Sent ${contactsToSendGreeting.length} message${contactsToSendGreeting.length > 1 ? "s" : ""} using template: "${selectedTemplateDetails.name}"`
//     );

//     setTimeout(() => {
//       setSuccessMessage("");
//     }, 5000);
//   };

//   const editingTemplateId = useRef(null);
//   const fileInputRef = useRef();
//   const handleEditImageClick = (templateId) => {
//     editingTemplateId.current = templateId;
//     fileInputRef.current.click();
//   };











//   const handleFileChange = async (event) => {
//     const file = event.target.files[0];
//     if (!file || !editingTemplateId.current) return;

//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('id', editingTemplateId.current);

//     try {
//       const response = await fetch('https://botapi.emedha.in/pages/api/api/updateGreeting', {
//         method: 'PUT',
//         body: formData,
//       });
//       const result = await response.json();

//       if (result.success) {
//         // 1. Fetch backend records to keep all background lists synced
//         await fetchGreetingMessage();

//         // 2. Generate a local instant preview URL for the uploaded file
//         const immediatePreviewUrl = URL.createObjectURL(file);
//         const isVideo = file.type.startsWith('video/');

//         // 3. Directly update the open modal view state right now
//         setSelectedTemplateDetails(prevDetails => {
//           if (!prevDetails) return prevDetails;

//           // Map across components to replace the old header asset handle dynamically
//           const updatedComponents = prevDetails.components.map(component => {
//             if (component.type === 'HEADER') {
//               return {
//                 ...component,
//                 format: isVideo ? 'VIDEO' : 'IMAGE',
//                 example: {
//                   header_handle: [immediatePreviewUrl] // Replaces old link instantly in the open view
//                 }
//               };
//             }
//             return component;
//           });

//           return {
//             ...prevDetails,
//             components: updatedComponents
//           };
//         });

//         alert('Media updated successfully!');
//       } else {
//         alert('Update failed: ' + result.message);
//       }
//     } catch (error) {
//       console.error('Upload error:', error);
//     }
//   };





//   const filteredContacts = selectedGroupContacts.filter(contact => {
//     return contact.name?.toLowerCase().includes(searchTerm.toLowerCase()) || contact.mobile?.includes(searchTerm);
//   });

//   const previewSelectedContacts = selectedGroupContacts.filter(contact =>
//     selectedContactIds.includes(contact.id)
//   );

//   const templateDescriptionText = selectedTemplateDetails?.components?.find(c => c.type === 'BODY')?.text || '';

//   return (
//     <div className="messaging-container">
//       <style>{`
//                 .messaging-container { display: flex; height: 100vh; background-color: #f3f4f6; font-family: "Inter", system-ui, -apple-system, sans-serif;color: #1f2937;overflow: hidden;width: 100%;}
//                 .sidebar-section { width: 340px; min-width: 310px; background-color: #ffffff; border-right: 1px solid #e5e7eb; padding: 10px; display: flex;flex-direction: column; box-shadow: 2px 0 8px rgba(0,0,0,0.02); height: 100vh; box-sizing: border-box;}
//                 .main-content-section { flex: 1; padding: 10px; display: flex; flex-direction: column; box-sizing: border-box; height: 100vh; overflow-y: auto;}
//                 .top-meta-header { padding: 20px 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center; background-color: #ffffff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 24px; border: 1px solid #e5e7eb; gap: 16px; }
//                 .campaign-preview-card {background-color: ${theme.card}; border-radius: 12px; border: 1px solid ${theme.border}; box-shadow: 0 1px 3px rgba(0,0,0,0.05); overflow: hidden; margin-bottom: 24px;}
//                 .media-and-message-grid {display: grid; grid-template-columns: 260px 1fr; gap: 24px; padding: 20px; background-color: #ffffff; border-bottom: 1px solid ${theme.border};}
//                 .grid-recipients-layout {padding: 16px; display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; max-height: 380px; overflow-y: auto;}

//                 /* 👇 ADD THESE TWO CSS RULES INSIDE YOUR STYLE BLOCK */
//                 .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
//                 .modal-content { background: white; padding: 24px; border-radius: 12px; width: 90%; max-width: 500px; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); }

//                 /* Round status bar counter indicator styles */
//         .status-counter-bar {
//           display: flex;
//           align-items: center;
//           gap: 14px;
//           background: #ffffff;
//           border: 1px solid #e5e7eb;
//           padding: 14px 20px;
//           border-radius: 14px;
//           margin-bottom: 20px;
//           box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
//         }
//         .round-counter-badge {
//           width: 42px;
//           height: 42px;
//           background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
//           color: #ffffff;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           font-size: 16px;
//           box-shadow: 0 2px 4px rgba(79, 70, 229, 0.3);
//           flex-shrink: 0;
//         }

//                 /* Responsive Breakpoints */
//                 @media (max-width: 1024px) {
//                     .messaging-container { flex-direction: column; height: auto; overflow: visible;}
//                     .sidebar-section { width: 100%; height: auto; border-right: none; border-bottom: 1px solid #e5e7eb; padding: 20px;}
//                     .main-content-section {width: 100%; height: auto; padding: 20px;}
//                     .media-and-message-grid { grid-template-columns: 1fr;}
//                     .media-preview-box { width: 100% !important; max-width: 340px; margin: 0 auto;}
//                     .sidebar-scroll-area { max-height: 250px;}
//                 }
//                 @media (max-width: 767px) {
//                     .top-meta-header { flex-direction: column;align-items: start; }
//                     .top-meta-header button { width: 100%; }
//                 }
//             `}</style>

//       {/* Left Control Panel Segment */}
//       <div className="sidebar-section">

//         <div style={{ marginBottom: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
//           <div>
//             <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Template</label>
//             <select value={selectedTemplateName} onChange={handleTemplateChange} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
//               <option value="">Select Template</option>
//               {templateList.map(template => (
//                 <option key={template.id} value={template.name}>{template.name}</option>
//               ))}
//             </select>
//           </div>

//           {selectedTemplateName && (
//             <div>
//               <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Group</label>
//               <select value={groupName} onChange={handleGroupChange} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
//                 <option value="">Select Group</option>
//                 {groupOptions.map((group, index) => (
//                   <option key={index} value={group}>{group}</option>
//                 ))}
//               </select>
//             </div>
//           )}

//           {groupName && groupedContacts[groupName] && (
//             <div>
//               <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Subgroup</label>
//               <select value={subgroupName} onChange={handleSubgroupChange} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
//                 <option value="">Select Subgroup</option>
//                 {Object.keys(groupedContacts[groupName]).map((subgroup, index) => (
//                   <option key={index} value={subgroup}>{subgroup}</option>
//                 ))}
//               </select>
//             </div>
//           )}
//         </div>

//         {subgroupName && (
//           <button onClick={resetAllTemplateDependentStates} style={{ width: '100%', padding: '10px 14px', marginBottom: '20px', border: '1px solid #fee2e2', borderRadius: '8px', backgroundColor: '#fef2f2', color: '#ef4444', fontWeight: '600', fontSize: '13px', cursor: 'pointer', textAlign: 'center' }}>Clear</button>
//         )}

//         <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
//           <h5 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '10px', marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <span>Members</span>
//             <span style={{ backgroundColor: '#e5e7eb', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', color: '#4b5563' }}>{filteredContacts.length}</span>
//           </h5>

//           {filteredContacts.length > 0 && (
//             <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
//               <button onClick={handleSelectAll} style={{ flex: 1, padding: '6px 12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#e0e7ff', color: '#4f46e5', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Select All</button>
//               <button onClick={handleDeselectAll} style={{ flex: 1, padding: '6px 12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#f3f4f6', color: '#4b5563', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Deselect All</button>
//             </div>
//           )}

//           {selectedGroupContacts.length > 0 && (
//             <input type="text" placeholder="🔍 Search members..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ width: '100%', padding: '10px 12px', marginBottom: '16px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
//           )}

//           <div className="sidebar-scroll-area" style={{ flex: 1, overflowY: 'auto', paddingRight: '4px' }}>
//             {filteredContacts.length > 0 ? (
//               <ul style={{ listStyleType: 'none', paddingLeft: '0', margin: '0' }}>
//                 {filteredContacts.map((contact) => (
//                   <li key={contact.id} style={{ padding: '12px', backgroundColor: '#f9fafb', border: '1px solid #f3f4f6', marginBottom: '10px', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
//                     <input type="checkbox" checked={selectedContactIds.includes(contact.id)} onChange={() => handleContactCheckboxChange(contact.id)} style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: theme.primary }} />
//                     <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => handleContactCheckboxChange(contact.id)}>
//                       <div style={{ fontWeight: '600', fontSize: '13px', color: '#111827' }}>{contact.name}</div>
//                       <div style={{ fontSize: '12px', color: '#6b7280' }}>{contact.mobile}</div>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <div style={{ textAlign: 'center', padding: '30px 10px', color: '#9ca3af', border: '2px dashed #e5e7eb', borderRadius: '12px', fontSize: '13px' }}>
//                 No targets match filters.
//               </div>
//             )}
//           </div>
//         </div>
//       </div>










//       {/* Right Side Content Segment */}
//       <div className="main-content-section">
//         {/* Sending Progress */}
//         {isSending && (
//           <div style={{ width: "100%", marginBottom: "20px", padding: "16px", borderRadius: "12px", border: "1px solid rgba(59,130,246,0.2)", backgroundColor: "rgba(59,130,246,0.05)", boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)", animation: "pulse 1.5s infinite", boxSizing: "border-box" }}        >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", marginBottom: "10px" }}        >
//               <span style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", color: "#3b82f6", letterSpacing: "1px" }}>
//                 <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} />
//                 Transmitting Messages...
//               </span>

//               <span style={{ fontSize: "14px", fontWeight: "700", fontFamily: "monospace", color: "#3b82f6" }}>
//                 {sentCount} / {selectedContactIds.length} Done ({progress}%)
//               </span>
//             </div>

//             <div style={{ width: "100%", height: "10px", background: "#e5e7eb", borderRadius: "999px", overflow: "hidden" }}>
//               <div style={{ width: `${progress}%`, height: "100%", background: "#3b82f6", transition: "width .3s ease" }} />
//             </div>
//           </div>
//         )}

//         {/* Success Message */}
//         {successMessage && (
//           <div style={{ width: "100%", marginBottom: "20px", padding: "16px", borderRadius: "12px", border: "1px solid rgba(34,197,94,.2)", background: "rgba(34,197,94,.08)", color: "#15803d", fontSize: "14px", fontWeight: "600", boxSizing: "border-box" }}>
//             {successMessage}
//           </div>
//         )}

//         {selectedTemplateDetails ? (

//           <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>












//             <div className="top-meta-header">
//               <div>
//                 <h4 style={{ margin: '0 0 6px 0', fontSize: '18px', fontWeight: '700', color: '#111827' }}>
//                   {groupName || 'No Group Selected'} {subgroupName && ` ➜ ${subgroupName}`}
//                 </h4>
//                 <span style={{ color: '#6b7280', fontSize: '13px' }}>Selected Table Name: <strong>{selectedTableName}</strong></span>
//               </div>
//             </div>
//             <div className="campaign-preview-card">
//               <div style={{ padding: '14px 16px', borderBottom: `1px solid ${theme.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: theme.mutedBg }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <MessageSquare size={15} style={{ color: theme.primary }} />
//                   <h2 style={{ fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>
//                     SELECTED MEMBERS
//                   </h2>
//                   <span style={{ padding: '2px 8px', borderRadius: '9999px', backgroundColor: theme.primaryLight, color: theme.primary, fontSize: '11px', fontWeight: '700' }}>
//                     {previewSelectedContacts.length} Selected
//                   </span>
//                 </div>
//               </div>

//               {previewSelectedContacts.length === 0 ? (
//                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 24px', textAlign: 'center' }}>
//                   <div style={{ width: '52px', height: '52px', borderRadius: '16px', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
//                     <Users size={22} style={{ color: theme.textMuted }} />
//                   </div>
//                   <p style={{ fontSize: '14px', fontWeight: '600', color: theme.textForeground, margin: 0 }}>
//                     Queue is empty
//                   </p>
//                   <p style={{ fontSize: '12px', color: theme.textMuted, marginTop: '4px', maxWidth: '320px' }}>
//                     No members selected. Check members on the left sidebar to add them to this campaign stream.
//                   </p>
//                 </div>
//               ) : (
//                 <div className="grid-recipients-layout">
//                   {previewSelectedContacts.map((contact, index) => (
//                     <div key={contact.id || index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px', borderRadius: '12px', border: `1px solid ${theme.primaryBorder}`, backgroundColor: 'rgba(79, 70, 229, 0.02)', position: 'relative' }}>
//                       <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
//                         <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: theme.primary, color: theme.primaryForeground, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>
//                           {contact.name ? contact.name[0].toUpperCase() : '?'}
//                         </div>
//                         <div style={{ minWidth: 0 }}>
//                           <p style={{ fontSize: '12px', fontWeight: '700', color: theme.textForeground, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                             {contact.name}
//                           </p>
//                           <p style={{ fontSize: '10px', color: theme.textMuted, fontFamily: 'monospace', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                             {contact.mobile}
//                           </p>
//                         </div>
//                       </div>
//                       <button type="button" disabled={isConfirmed}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           if (!isConfirmed) {
//                             handleRemoveIndividualContact(contact.id);
//                           }
//                         }}
//                         style={{ padding: "4px", color: theme.textMuted, backgroundColor: "transparent", border: "none", cursor: isConfirmed ? "not-allowed" : "pointer", opacity: isConfirmed ? 0.4 : 1, borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", }} title="Remove contact">
//                         <X size={14} />
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               <div style={{ padding: '16px', borderTop: `1px solid ${theme.border}`, backgroundColor: theme.mutedBg, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//                   {groupName && (
//                     <button
//                       onClick={async () => {
//                         if (isConfirmed) {
//                           handleResetFlag("reConfirm");
//                         } else {
//                           await handleResetFlag("confirm");
//                           setIsConfirmModalOpen(true);
//                         }
//                       }}
//                       style={{ padding: "10px 16px", fontSize: "12px", fontWeight: "700", borderRadius: "8px", backgroundColor: isConfirmed ? "#f59e0b" : "#374151", color: "#fff", border: "none", cursor: "pointer", whiteSpace: "nowrap", }}
//                     >
//                       {isConfirmed ? "Clear" : "Confirm"}
//                     </button>
//                   )}

//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '2px dashed #e5e7eb', borderRadius: '16px', backgroundColor: '#ffffff', padding: '40px', minHeight: '340px' }}>
//             <div style={{ fontSize: '48px', marginBottom: '16px' }}>📁</div>
//             <h4 style={{ color: '#4b5563', margin: '0 0 6px 0', fontSize: '16px', fontWeight: '600' }}>No Active Workspace Stream</h4>
//             <p style={{ color: '#9ca3af', margin: '0', fontSize: '14px', textAlign: 'center' }}>Please configure a Messaging Template on the sidebar setup to initialize preview options.</p>
//           </div>
//         )}
//       </div>










//       {isConfirmModalOpen && (
//         <div className="modal-overlay" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.4)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, padding: '12px' }}>
//           <div className="modal-content" style={{ background: '#ffffff', borderRadius: '12px', width: '100%', maxWidth: '420px', maxHeight: '90vh', boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.2)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>





//             <div className="status-counter-bar">
//               <div className="round-counter-badge">
//                 {previewSelectedContacts.length}
//               </div>
//               <div>
//                 <h4 style={{ margin: '0 0 2px 0', fontSize: '15px', fontWeight: '700', color: '#111827' }}>Ready to Send Message</h4>
//                 <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
//                   Total of <strong>{previewSelectedContacts.length}</strong> selected user{previewSelectedContacts.length === 1 ? '' : 's'} queued to receive messages.
//                 </p>
//               </div>
//             </div>




//             {/* Tight Header */}
//             <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#111827' }}>Campaign Summary</h3>
//               <button type="button" onClick={() => setIsConfirmModalOpen(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', padding: '4px' }}>
//                 <X size={16} />
//               </button>
//             </div>

//             {/* Compact Scrollable Body Container */}
//             <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto', flex: 1 }}>

//               {/* 1. Template Identity */}
//               <div>
//                 <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4f46e5', letterSpacing: '0.05em', marginBottom: '4px' }}>Template</label>
//                 <div style={{ padding: '8px 12px', background: '#f9fafb', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '13px', fontWeight: '600', color: '#111827' }}>
//                   {selectedTemplateName || "No template configured"}
//                 </div>
//               </div>

//               {/* 2. Medium-Sized Media Block */}
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                 <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4f46e5', letterSpacing: '0.05em' }}>
//                   Media Preview
//                 </label>

//                 <div className="media-preview-box" style={{ position: 'relative', width: '100%', height: '160px', backgroundColor: '#f3f4f6', borderRadius: '6px', border: '1px solid #e5e7eb', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '4px' }}>
//                   {(() => {
//                     const headerComp = selectedTemplateDetails?.components?.find(c => c.type === 'HEADER');
//                     const headerUrl = headerComp?.example?.header_handle?.[0];
//                     if (!headerUrl) {
//                       return <p style={{ padding: '8px', fontSize: '12px', color: '#6b7280', textAlign: 'center', margin: 0 }}>No Media Configured</p>;
//                     }

//                     // Check if it's an inline browser Object Blob URL preview
//                     const isBlob = headerUrl.startsWith('blob:');

//                     // Safely extract format fallback checks
//                     let fileExtension = '';
//                     if (!isBlob) {
//                       fileExtension = headerUrl.split('.').pop().toLowerCase();
//                     }

//                     // Detect image formats natively
//                     const isImage = isBlob
//                       ? headerComp.format === 'IMAGE'
//                       : ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);

//                     // Detect video formats natively
//                     const isVideo = isBlob
//                       ? headerComp.format === 'VIDEO'
//                       : ['mp4', 'webm', 'mov', 'avi'].includes(fileExtension);

//                     // Detect documents
//                     const isPdf = !isBlob && fileExtension === 'pdf';

//                     if (isImage) {
//                       return <img src={headerUrl} alt="Header Preview" style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#f9fafb' }} />;
//                     } else if (isVideo) {
//                       return (
//                         <video controls key={headerUrl} style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000000' }}>
//                           <source src={headerUrl} type={isBlob ? "video/mp4" : `video/${fileExtension}`} />
//                         </video>
//                       );
//                     } else if (isPdf) {
//                       return <iframe src={headerUrl} style={{ width: '100%', height: '100%', border: 'none' }} title="PDF Preview" />;
//                     }

//                     return <p style={{ padding: '4px', fontSize: '11px', margin: 0 }}>Unsupported Format</p>;
//                   })()}

//                   {/* Absolute Edit Trigger Overlay */}
//                   <div onClick={() => handleEditImageClick(selectedTemplateDetails?.id)} style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(17, 24, 39, 0.6)', color: '#ffffff', cursor: 'pointer', opacity: 0, transition: 'opacity 0.2s ease', fontSize: '12px', fontWeight: '600' }}
//                     onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
//                     onMouseLeave={(e) => e.currentTarget.style.opacity = '0'}
//                   >
//                     <FaEdit size={18} style={{ marginBottom: '4px' }} />
//                     <span>Update Media</span>
//                   </div>
//                 </div>

//                 {/* Hidden File Input */}
//                 <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*,application/pdf,video/*" style={{ display: 'none' }} />
//               </div>

//               {/* 3. Small Text Area */}
//               <div>
//                 <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4f46e5', letterSpacing: '0.05em', marginBottom: '4px' }}>Message Body</label>
//                 <div style={{ padding: '10px', background: '#fcfcfd', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '12px', color: '#374151', whiteSpace: 'pre-wrap', lineHeight: '1.4', maxHeight: '80px', overflowY: 'auto' }}>
//                   {templateDescriptionText || <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>No description content.</span>}
//                 </div>
//               </div>

//               {/* 4. Total Target Indicator */}
//               <div style={{ padding: '10px 12px', background: 'rgba(79, 70, 229, 0.04)', borderRadius: '6px', border: `1px solid ${theme.primaryBorder}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <span style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Recipients Selected:</span>
//                 <span style={{ background: theme.primary, color: '#ffffff', padding: '2px 10px', borderRadius: '9999px', fontSize: '12px', fontWeight: '700' }}>
//                   {previewSelectedContacts.length}
//                 </span>
//               </div>

//             </div>

//             {/* Micro Action Bar */}
//             <div style={{ padding: '10px 16px', borderTop: '1px solid #e5e7eb', background: '#f9fafb', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
//               <button type="button" onClick={() => setIsConfirmModalOpen(false)} style={{ padding: '8px 14px', background: '#ffffff', color: '#374151', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>Cancel</button>
//               <button
//                 type="button"
//                 onClick={async () => {
//                   await handleResetFlag("confirm");
//                   await handleSendGreeting();
//                   setIsConfirmModalOpen(false);
//                 }}
//                 disabled={isSending || selectedContactIds.length === 0}
//                 style={{ display: 'inline-flex', alignItems: 'center', justify: 'center', gap: '6px', padding: '8px 14px', borderRadius: '6px', backgroundColor: (isSending || selectedContactIds.length === 0) ? '#d1d5db' : theme.primary, color: theme.primaryForeground, border: 'none', fontSize: '12px', fontWeight: '700', cursor: (isSending || selectedContactIds.length === 0) ? 'not-allowed' : 'pointer', transition: 'all 0.15s ease' }}
//               >
//                 <Send size={12} />
//                 {isSending ? 'Sending...' : 'Send'}
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SendMessaging;

























import { useState, useEffect, useRef } from 'react';

import { FaEdit } from 'react-icons/fa';
import { MessageSquare, Users, Send, X, RefreshCw } from 'lucide-react';

// Theme configuration fallback block based on your design sample aesthetics
const theme = { primary: '#4f46e5', primaryLight: 'rgba(79, 70, 229, 0.1)', primaryBorder: 'rgba(79, 70, 229, 0.15)', primaryForeground: '#ffffff', card: '#ffffff', border: '#e5e7eb', mutedBg: '#f9fafb', textForeground: '#111827', textMuted: '#6b7280' };

const SendMessaging = () => {
  // 1. Template States
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplateName, setSelectedTemplateName] = useState('');
  const [selectedTemplateDetails, setSelectedTemplateDetails] = useState(null);

  // 2. Data States dependent on Template
  const [groupName, setGroupName] = useState('');
  // const [subgroupName, setSubgroupName] = useState('');
  const [subgroupName, setSubgroupName] = useState([]);

  const [groupOptions, setGroupOptions] = useState([]);
  const [groupedContacts, setGroupedContacts] = useState({});
  const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);


  // 3. Selection & Search States
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(false); // 👈 ADD THIS LINE

  const [greetingMessage, setGreetingMessage] = useState('');
  const [sendMessage, setSendMessage] = useState(null);
  const [waId, setWaId] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [selectedTableName, setSelectedTableName] = useState('');

  const [sentCount, setSentCount] = useState(0);
  const [progress, setProgress] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");



  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  useEffect(() => {
    fetchGreetingMessage();
  }, []);

  useEffect(() => {
    if (selectedTableName) {
      fetchContacts();
    }
  }, [selectedTableName]);

  // useEffect(() => {
  //   if (groupName && groupedContacts[groupName]) {
  //     const subgroup = subgroupName || 'No Subgroup';
  //     const contacts = groupedContacts[groupName][subgroup] || [];
  //     setSelectedGroupContacts(contacts);
  //     // setSelectedContactIds(contacts.map(c => c.id));
  //     // Keep only the members that were already selected
  //     setSelectedContactIds(prev =>
  //       prev.filter(id => contacts.some(contact => contact.id === id))
  //     );
  //   } else {
  //     setSelectedGroupContacts([]);
  //     setSelectedContactIds([]);
  //   }
  // }, [groupName, subgroupName, groupedContacts]);

  useEffect(() => {
    if (groupName && groupedContacts[groupName]) {
      const selectedSubgroups =
        subgroupName.length > 0
          ? subgroupName
          : ['No Subgroup'];

      const contacts = selectedSubgroups.flatMap(
        subgroup => groupedContacts[groupName][subgroup] || []
      );

      setSelectedGroupContacts(contacts);

      setSelectedContactIds(prev =>
        prev.filter(id =>
          contacts.some(contact => contact.id === id)
        )
      );
    } else {
      setSelectedGroupContacts([]);
      setSelectedContactIds([]);
    }
  }, [groupName, subgroupName, groupedContacts]);

  const fetchGreetingMessage = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      const wa_id = user?.wa_id;
      const p_id = user?.p_id;
      setWaId(wa_id);
      if (!wa_id || !p_id) {
        setGreetingMessage(null);
        setSendMessage(null);
        setTemplateList([]);
        return;
      }
      const response = await fetch('https://botapi.emedha.in/pages/api/getConfig');
      const data = await response.json();
      if (data.success && Array.isArray(data.data)) {
        const userMessages = data.data.filter(item => item.wa_id === wa_id && item.p_id === p_id);
        if (userMessages.length > 0) {
          setGreetingMessage(userMessages[0]);
          setSendMessage(userMessages[1] || null);

          // Map template objects matching API configurations explicitly
          const templates = userMessages
            .filter(item => item.template_name)
            .map(item => ({
              id: String(item.id), // Ensure it captures the "109" primary database key string safely
              name: item.template_name,
              message: item.message || '',
              header_image: item.header_image,
              header_type: item.header_type || 'image',
              table_name: item.table_name,
            }));
          setTemplateList(templates);
        } else {
          resetAllTemplateDependentStates();
        }
      } else {
        resetAllTemplateDependentStates();
      }
    } catch (err) {
      console.error('Error fetching greeting message:', err);
      resetAllTemplateDependentStates();
    }
  };

  const resetAllTemplateDependentStates = () => {
    setSelectedTemplateName('');
    setSelectedTemplateDetails(null);
    setSelectedTableName('');
    setGroupName('');
    // setSubgroupName('');
    setSubgroupName([]);
    setGroupOptions([]);
    setGroupedContacts({});
    setSelectedGroupContacts([]);
    setSearchTerm('');
    setSelectedContactIds([]);
    setIsConfirmed(false);
  };


  const handleTemplateChange = async (e) => {
    const templateName = e.target.value;
    setSelectedTemplateName(templateName);
    setGroupName('');
    // setSubgroupName('');
    setSubgroupName([]);
    setGroupOptions([]);
    setGroupedContacts({});
    setSelectedGroupContacts([]);
    setSearchTerm('');
    setSelectedContactIds([]);

    if (!templateName) {
      setSelectedTemplateDetails(null);
      setSelectedTableName('');
      return;
    }

    // 1. Capture local structural configurations safely
    const selected = templateList.find(t => t.name === templateName);
    let localHeaderComponent = null;
    let localBodyText = ' ';
    let localId = '';

    if (selected) {
      setSelectedTableName(selected.table_name || '');
      localId = selected.id || greetingMessage?.id; // 🌟 FALLBACK: If selected mapping failed, grab it from base greetingMessage state
      localBodyText = selected.message || ' ';

      localHeaderComponent = selected.header_type === 'video'
        ? { type: 'HEADER', format: 'VIDEO', example: { header_handle: [selected.header_video] } }
        : { type: 'HEADER', format: 'IMAGE', example: { header_handle: [selected.header_image] } };
    } else if (greetingMessage) {
      // Emergency absolute fallback directly from base config payload row context data
      localId = greetingMessage.id;
      setSelectedTableName(greetingMessage.table_name || '');
    }

    try {
      // 2. Fetch the approved layout elements 
      const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateInfo.php?name=${templateName}&wid=${waId}`);
      const resData = await response.json();

      if (resData && resData.data && resData.data.length > 0) {
        const officialTemplate = resData.data[0];
        const officialBodyComponent = officialTemplate.components?.find(c => c.type === 'BODY') || { type: 'BODY', text: localBodyText };

        // 3. Bind absolute verified DB Context values
        setSelectedTemplateDetails({
          id: localId, // This passes "109" upstream to handleFileChange context explicitly!
          whatsapp_meta_id: officialTemplate.id,
          name: templateName,
          components: [
            localHeaderComponent,
            officialBodyComponent
          ].filter(Boolean)
        });

      } else {
        setSelectedTemplateDetails({
          id: localId,
          name: templateName,
          components: [localHeaderComponent, { type: 'BODY', text: localBodyText }].filter(Boolean),
        });
      }
    } catch (err) {
      console.error('Error merging official body layout:', err);
      setSelectedTemplateDetails({
        id: localId,
        name: templateName,
        components: [localHeaderComponent, { type: 'BODY', text: localBodyText }].filter(Boolean),
      });
    }
  };











  const fetchContacts = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      if (!user || !user.id || !selectedTableName) return;

      const queryParams = new URLSearchParams();
      queryParams.append('user_id', user.id);
      queryParams.append('table_name', selectedTableName);

      const response = await fetch(`https://botapi.emedha.in/pages/api/api/contacts/user?${queryParams.toString()}`);
      if (!response.ok) throw new Error('Failed to fetch contacts');

      const data = await response.json();

      const groupedData = data.contacts.reduce((acc, contact) => {
        const group = contact.group_name || 'No Group';
        const subgroup = contact.subgroup_name || 'No Subgroup';
        if (!acc[group]) acc[group] = {};
        if (!acc[group][subgroup]) acc[group][subgroup] = [];
        acc[group][subgroup].push({
          ...contact,
          group_id: contact.group_id,
          subgroup_id: contact.subgroup_id,
        });
        return acc;
      }, {});

      setGroupedContacts(groupedData);
      setGroupOptions(Object.keys(groupedData));
    } catch (err) {
      console.error('Error fetching contacts:', err);
    }
  };


  // const handleGroupChange = (e) => {
  //   setGroupName(e.target.value);
  //   setSubgroupName('');
  //   setSelectedGroupContacts([]);
  //   setSelectedContactIds([]);
  //   setSearchTerm('');
  //   const contacts =
  //     groupedContacts[e.target.value]?.["No Subgroup"] || [];

  //   if (contacts.length > 0) {

  //     const ids = contacts.map(c => c.id);

  //     setSelectedGroupContacts(contacts);

  //     setSelectedContactIds(ids);

  //     updateSelectedMembersFlag(ids);

  //   }
  // };

  const handleGroupChange = (e) => {
    const selectedGroup = e.target.value;

    setGroupName(selectedGroup);
    setSubgroupName([]);
    setSelectedGroupContacts([]);
    setSelectedContactIds([]);
    setSearchTerm('');

    // Keep the existing No Subgroup default behavior.
    const contacts =
      groupedContacts[selectedGroup]?.['No Subgroup'] || [];

    if (contacts.length > 0) {
      const ids = contacts.map(contact => contact.id);

      setSelectedGroupContacts(contacts);
      setSelectedContactIds(ids);

      updateSelectedMembersFlag(ids);
    }
  };


  // const handleSubgroupChange = (e) => {
  //   const subgroup = e.target.value;
  //   setSubgroupName(subgroup);
  //   const selectedContacts = groupedContacts[groupName][subgroup || 'No Subgroup'] || [];
  //   setSelectedGroupContacts(selectedContacts);
  //   // setSelectedContactIds(selectedContacts.map(c => c.id));
  //   const ids = selectedContacts.map(c => c.id);

  //   setSelectedContactIds(ids);

  //   updateSelectedMembersFlag(ids);
  //   setSearchTerm('');
  // };


  const handleSubgroupChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      option => option.value
    );

    setSubgroupName(selectedOptions);

    const contacts = selectedOptions.flatMap(
      subgroup => groupedContacts[groupName]?.[subgroup] || []
    );

    setSelectedGroupContacts(contacts);

    setSelectedContactIds(contacts.map(contact => contact.id));

    setSearchTerm('');

    if (contacts.length > 0) {
      updateSelectedMembersFlag(contacts.map(contact => contact.id));
    }
  };


  const handleContactCheckboxChange = (contactId) => {
    if (selectedContactIds.includes(contactId)) {
      setSelectedContactIds(selectedContactIds.filter(id => id !== contactId));
    } else {
      setSelectedContactIds([...selectedContactIds, contactId]);
    }
  };

  // Remove single contact via the cross button click inside the dynamic view grid
  const handleRemoveIndividualContact = (contactId) => {
    setSelectedContactIds(selectedContactIds.filter(id => id !== contactId));
  };

  const handleSelectAll = () => {
    const filteredIds = filteredContacts.map(c => c.id);
    const newSelection = Array.from(new Set([...selectedContactIds, ...filteredIds]));
    setSelectedContactIds(newSelection);
  };

  const handleDeselectAll = () => {
    const filteredIds = filteredContacts.map(c => c.id);
    const newSelection = selectedContactIds.filter(id => !filteredIds.includes(id));
    setSelectedContactIds(newSelection);
  };


  const handleResetFlag = async (flagType) => {
    if (groupName && groupedContacts[groupName]) {

      const contactIds = selectedContactIds.filter(id => id);
      const user = JSON.parse(sessionStorage.getItem('user'));
      const userId = user?.id;

      if (!userId || !selectedTableName) {
        alert("User session or template configuration dataset table not found.");
        return;
      }

      if (contactIds.length === 0) {
        alert("Please select at least one member.");
        return;
      }

      try {
        const response = await fetch("https://botapi.emedha.in/pages/api/reset-flag",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              tableName: selectedTableName,
              groupName,
              // subgroupName: subgroupName || "",
              subgroupName: subgroupName.join(', '),
              contactIds,
              userId,
              flag: flagType, // <-- IMPORTANT
            }),
          }
        );

        const data = await response.json();

        if (data.success) {

          setIsConfirmed(flagType === "confirm");

          await fetchContacts();

        } else {
          alert(data.error);
        }

      } catch (err) {
        console.error(err);
      }
    }
  };


  const updateSelectedMembersFlag = async (contactIds) => {

    const user = JSON.parse(sessionStorage.getItem("user"));
    const userId = user?.id;

    if (!userId || !selectedTableName || contactIds.length === 0) {
      return;
    }

    try {

      const response = await fetch(
        "https://botapi.emedha.in/pages/api/select-members-flag",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tableName: selectedTableName,
            groupName,
            // subgroupName: subgroupName || "",
            subgroupName: subgroupName.join(', '),
            contactIds,
            userId,
          }),
        }
      );

      const data = await response.json();

      if (!data.success) {
        console.error(data.error);
      }

    } catch (err) {
      console.error(err);
    }

  };

  const handleSendGreeting = async () => {
    setIsSending(true);
    setSuccessMessage("");
    setSentCount(0);
    setProgress(0);
    const contactsToProcess = selectedGroupContacts.filter(contact =>
      selectedContactIds.includes(contact.id)
    );

    if (contactsToProcess.length === 0) {
      alert('Please select at least one checked member from the list to send messaging.');
      setIsSending(false);
      return;
    }

    const contactsToSendGreeting = contactsToProcess.filter(contact => contact.flag !== 1);
    if (contactsToSendGreeting.length === 0) {
      alert('All targeted contacts have flag set to 1. Cannot send greetings! Please click on Reset button.');
      setIsSending(false);
      return;
    }

    if (!selectedTemplateDetails?.name) {
      alert('Template not selected.');
      setIsSending(false);
      return;
    }

    for (const contact of contactsToSendGreeting) {
      const payload = {
        groupId: contact.group_id?.toString(),
        subGroupId: contact.subgroup_id?.toString(),
        wid: waId,
        tempname: selectedTemplateDetails.name
      };
      try {
        const response = await fetch('https://emedha.com/echatbot/enotifier/dtemplate.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        await response.json();
        setSentCount(prev => {
          const current = prev + 1;
          setProgress(
            Math.round((current / contactsToSendGreeting.length) * 100)
          );
          return current;
        });
      } catch (error) {
        console.error(`❌ Error sending payload for ${contact.name}:`, error);
      }
    }

    // setIsSending(false);
    // alert('Messages sent safely to selected target users!');
    setIsSending(false);

    setSuccessMessage(
      `✅ Successfully finished! Sent ${contactsToSendGreeting.length} message${contactsToSendGreeting.length > 1 ? "s" : ""} using template: "${selectedTemplateDetails.name}"`
    );

    setTimeout(() => {
      setSuccessMessage("");
    }, 5000);
  };

  const editingTemplateId = useRef(null);
  const fileInputRef = useRef();
  const handleEditImageClick = (templateId) => {
    editingTemplateId.current = templateId;
    fileInputRef.current.click();
  };











  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file || !editingTemplateId.current) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', editingTemplateId.current);

    try {
      const response = await fetch('https://botapi.emedha.in/pages/api/api/updateGreeting', {
        method: 'PUT',
        body: formData,
      });
      const result = await response.json();

      if (result.success) {
        // 1. Fetch backend records to keep all background lists synced
        await fetchGreetingMessage();

        // 2. Generate a local instant preview URL for the uploaded file
        const immediatePreviewUrl = URL.createObjectURL(file);
        const isVideo = file.type.startsWith('video/');

        // 3. Directly update the open modal view state right now
        setSelectedTemplateDetails(prevDetails => {
          if (!prevDetails) return prevDetails;

          // Map across components to replace the old header asset handle dynamically
          const updatedComponents = prevDetails.components.map(component => {
            if (component.type === 'HEADER') {
              return {
                ...component,
                format: isVideo ? 'VIDEO' : 'IMAGE',
                example: {
                  header_handle: [immediatePreviewUrl] // Replaces old link instantly in the open view
                }
              };
            }
            return component;
          });

          return {
            ...prevDetails,
            components: updatedComponents
          };
        });

        alert('Media updated successfully!');
      } else {
        alert('Update failed: ' + result.message);
      }
    } catch (error) {
      console.error('Upload error:', error);
    }
  };





  const filteredContacts = selectedGroupContacts.filter(contact => {
    return contact.name?.toLowerCase().includes(searchTerm.toLowerCase()) || contact.mobile?.includes(searchTerm);
  });

  const previewSelectedContacts = selectedGroupContacts.filter(contact =>
    selectedContactIds.includes(contact.id)
  );

  const templateDescriptionText = selectedTemplateDetails?.components?.find(c => c.type === 'BODY')?.text || '';

  return (
    <div className="messaging-container">
      <style>{`
                .messaging-container { display: flex; height: 100vh; background-color: #f3f4f6; font-family: "Inter", system-ui, -apple-system, sans-serif;color: #1f2937;overflow: hidden;width: 100%;}
                .sidebar-section { width: 340px; min-width: 310px; background-color: #ffffff; border-right: 1px solid #e5e7eb; padding: 10px; display: flex;flex-direction: column; box-shadow: 2px 0 8px rgba(0,0,0,0.02); height: 100vh; box-sizing: border-box;}
                .main-content-section { flex: 1; padding: 10px; display: flex; flex-direction: column; box-sizing: border-box; height: 100vh; overflow-y: auto;}
                .top-meta-header { padding: 20px 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center; background-color: #ffffff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 24px; border: 1px solid #e5e7eb; gap: 16px; }
                .campaign-preview-card {background-color: ${theme.card}; border-radius: 12px; border: 1px solid ${theme.border}; box-shadow: 0 1px 3px rgba(0,0,0,0.05); overflow: hidden; margin-bottom: 24px;}
                .media-and-message-grid {display: grid; grid-template-columns: 260px 1fr; gap: 24px; padding: 20px; background-color: #ffffff; border-bottom: 1px solid ${theme.border};}
                .grid-recipients-layout {padding: 16px; display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; max-height: 380px; overflow-y: auto;}

                /* 👇 ADD THESE TWO CSS RULES INSIDE YOUR STYLE BLOCK */
                .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
                .modal-content { background: white; padding: 24px; border-radius: 12px; width: 90%; max-width: 500px; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); }

                /* Round status bar counter indicator styles */
        .status-counter-bar {
          display: flex;
          align-items: center;
          gap: 14px;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          padding: 14px 20px;
          border-radius: 14px;
          margin-bottom: 20px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }
        .round-counter-badge {
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
          color: #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 16px;
          box-shadow: 0 2px 4px rgba(79, 70, 229, 0.3);
          flex-shrink: 0;
        }

                /* Responsive Breakpoints */
                @media (max-width: 1024px) {
                    .messaging-container { flex-direction: column; height: auto; overflow: visible;}
                    .sidebar-section { width: 100%; height: auto; border-right: none; border-bottom: 1px solid #e5e7eb; padding: 20px;}
                    .main-content-section {width: 100%; height: auto; padding: 20px;}
                    .media-and-message-grid { grid-template-columns: 1fr;}
                    .media-preview-box { width: 100% !important; max-width: 340px; margin: 0 auto;}
                    .sidebar-scroll-area { max-height: 250px;}
                }
                @media (max-width: 767px) {
                    .top-meta-header { flex-direction: column;align-items: start; }
                    .top-meta-header button { width: 100%; }
                }
            `}</style>

      {/* Left Control Panel Segment */}
      <div className="sidebar-section">

        <div style={{ marginBottom: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Template</label>
            <select value={selectedTemplateName} onChange={handleTemplateChange} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <option value="">Select Template</option>
              {templateList.map(template => (
                <option key={template.id} value={template.name}>{template.name}</option>
              ))}
            </select>
          </div>

          {selectedTemplateName && (
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Group</label>
              <select value={groupName} onChange={handleGroupChange} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                <option value="">Select Group</option>
                {groupOptions.map((group, index) => (
                  <option key={index} value={group}>{group}</option>
                ))}
              </select>
            </div>
          )}

          {/* {groupName && groupedContacts[groupName] && (
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Subgroup</label>
              <select value={subgroupName} onChange={handleSubgroupChange} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                <option value="">Select Subgroup</option>
                {Object.keys(groupedContacts[groupName]).map((subgroup, index) => (
                  <option key={index} value={subgroup}>{subgroup}</option>
                ))}
              </select>
            </div>
          )} */}

          {groupName && groupedContacts[groupName] && (
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '6px' }}>Select Subgroup (Multiple)</label>
              <select multiple value={subgroupName} onChange={handleSubgroupChange} style={{ width: '100%', minHeight: '130px', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#ffffff', outline: 'none', color: '#374151', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                {Object.keys(groupedContacts[groupName]).map(
                  (subgroup, index) => (
                    <option key={index} value={subgroup}>{subgroup}</option>
                  )
                )}
              </select>
              <small style={{ color: '#6b7280', fontSize: '11px' }}>Hold Ctrl (Windows) or Cmd (Mac) to select multiple subgroups.</small>
            </div>
          )}
        </div>

        {/* {subgroupName && ( */}
        {subgroupName.length > 0 && (
          <button onClick={resetAllTemplateDependentStates} style={{ width: '100%', padding: '10px 14px', marginBottom: '20px', border: '1px solid #fee2e2', borderRadius: '8px', backgroundColor: '#fef2f2', color: '#ef4444', fontWeight: '600', fontSize: '13px', cursor: 'pointer', textAlign: 'center' }}>Clear</button>
        )}

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <h5 style={{ color: '#374151', fontSize: '13px', fontWeight: '600', marginBottom: '10px', marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Members</span>
            <span style={{ backgroundColor: '#e5e7eb', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', color: '#4b5563' }}>{filteredContacts.length}</span>
          </h5>

          {filteredContacts.length > 0 && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
              <button onClick={handleSelectAll} style={{ flex: 1, padding: '6px 12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#e0e7ff', color: '#4f46e5', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Select All</button>
              <button onClick={handleDeselectAll} style={{ flex: 1, padding: '6px 12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#f3f4f6', color: '#4b5563', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Deselect All</button>
            </div>
          )}

          {selectedGroupContacts.length > 0 && (
            <input type="text" placeholder="🔍 Search members..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ width: '100%', padding: '10px 12px', marginBottom: '16px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }} />
          )}

          <div className="sidebar-scroll-area" style={{ flex: 1, overflowY: 'auto', paddingRight: '4px' }}>
            {filteredContacts.length > 0 ? (
              <ul style={{ listStyleType: 'none', paddingLeft: '0', margin: '0' }}>
                {filteredContacts.map((contact) => (
                  <li key={contact.id} style={{ padding: '12px', backgroundColor: '#f9fafb', border: '1px solid #f3f4f6', marginBottom: '10px', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <input type="checkbox" checked={selectedContactIds.includes(contact.id)} onChange={() => handleContactCheckboxChange(contact.id)} style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: theme.primary }} />
                    <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => handleContactCheckboxChange(contact.id)}>
                      <div style={{ fontWeight: '600', fontSize: '13px', color: '#111827' }}>{contact.name}</div>
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>{contact.mobile}</div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div style={{ textAlign: 'center', padding: '30px 10px', color: '#9ca3af', border: '2px dashed #e5e7eb', borderRadius: '12px', fontSize: '13px' }}>
                No targets match filters.
              </div>
            )}
          </div>
        </div>
      </div>










      {/* Right Side Content Segment */}
      <div className="main-content-section">
        {/* Sending Progress */}
        {isSending && (
          <div style={{ width: "100%", marginBottom: "20px", padding: "16px", borderRadius: "12px", border: "1px solid rgba(59,130,246,0.2)", backgroundColor: "rgba(59,130,246,0.05)", boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)", animation: "pulse 1.5s infinite", boxSizing: "border-box" }}        >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", marginBottom: "10px" }}        >
              <span style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", color: "#3b82f6", letterSpacing: "1px" }}>
                <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} />
                Transmitting Messages...
              </span>

              <span style={{ fontSize: "14px", fontWeight: "700", fontFamily: "monospace", color: "#3b82f6" }}>
                {sentCount} / {selectedContactIds.length} Done ({progress}%)
              </span>
            </div>

            <div style={{ width: "100%", height: "10px", background: "#e5e7eb", borderRadius: "999px", overflow: "hidden" }}>
              <div style={{ width: `${progress}%`, height: "100%", background: "#3b82f6", transition: "width .3s ease" }} />
            </div>
          </div>
        )}

        {/* Success Message */}
        {successMessage && (
          <div style={{ width: "100%", marginBottom: "20px", padding: "16px", borderRadius: "12px", border: "1px solid rgba(34,197,94,.2)", background: "rgba(34,197,94,.08)", color: "#15803d", fontSize: "14px", fontWeight: "600", boxSizing: "border-box" }}>
            {successMessage}
          </div>
        )}

        {selectedTemplateDetails ? (

          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>












            <div className="top-meta-header">
              <div>
                <h4 style={{ margin: '0 0 6px 0', fontSize: '18px', fontWeight: '700', color: '#111827' }}>
                  {/* {groupName || 'No Group Selected'} {subgroupName && ` ➜ ${subgroupName}`} */}{groupName || 'No Group Selected'}{subgroupName.length > 0 && ` ➜ ${subgroupName.join(', ')}`}
                </h4>
                <span style={{ color: '#6b7280', fontSize: '13px' }}>Selected Table Name: <strong>{selectedTableName}</strong></span>
              </div>
            </div>
            <div className="campaign-preview-card">
              <div style={{ padding: '14px 16px', borderBottom: `1px solid ${theme.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: theme.mutedBg }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <MessageSquare size={15} style={{ color: theme.primary }} />
                  <h2 style={{ fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>
                    SELECTED MEMBERS
                  </h2>
                  <span style={{ padding: '2px 8px', borderRadius: '9999px', backgroundColor: theme.primaryLight, color: theme.primary, fontSize: '11px', fontWeight: '700' }}>
                    {previewSelectedContacts.length} Selected
                  </span>
                </div>
              </div>

              {previewSelectedContacts.length === 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 24px', textAlign: 'center' }}>
                  <div style={{ width: '52px', height: '52px', borderRadius: '16px', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
                    <Users size={22} style={{ color: theme.textMuted }} />
                  </div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: theme.textForeground, margin: 0 }}>
                    Queue is empty
                  </p>
                  <p style={{ fontSize: '12px', color: theme.textMuted, marginTop: '4px', maxWidth: '320px' }}>
                    No members selected. Check members on the left sidebar to add them to this campaign stream.
                  </p>
                </div>
              ) : (
                <div className="grid-recipients-layout">
                  {previewSelectedContacts.map((contact, index) => (
                    <div key={contact.id || index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px', borderRadius: '12px', border: `1px solid ${theme.primaryBorder}`, backgroundColor: 'rgba(79, 70, 229, 0.02)', position: 'relative' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
                        <div style={{ width: '28px', height: '28px', borderRadius: '50%', backgroundColor: theme.primary, color: theme.primaryForeground, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>
                          {contact.name ? contact.name[0].toUpperCase() : '?'}
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <p style={{ fontSize: '12px', fontWeight: '700', color: theme.textForeground, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {contact.name}
                          </p>
                          <p style={{ fontSize: '10px', color: theme.textMuted, fontFamily: 'monospace', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {contact.mobile}
                          </p>
                        </div>
                      </div>
                      <button type="button" disabled={isConfirmed}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isConfirmed) {
                            handleRemoveIndividualContact(contact.id);
                          }
                        }}
                        style={{ padding: "4px", color: theme.textMuted, backgroundColor: "transparent", border: "none", cursor: isConfirmed ? "not-allowed" : "pointer", opacity: isConfirmed ? 0.4 : 1, borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", }} title="Remove contact">
                        <X size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <div style={{ padding: '16px', borderTop: `1px solid ${theme.border}`, backgroundColor: theme.mutedBg, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  {groupName && (
                    <button
                      onClick={async () => {
                        if (isConfirmed) {
                          handleResetFlag("reConfirm");
                        } else {
                          await handleResetFlag("confirm");
                          setIsConfirmModalOpen(true);
                        }
                      }}
                      style={{ padding: "10px 16px", fontSize: "12px", fontWeight: "700", borderRadius: "8px", backgroundColor: isConfirmed ? "#f59e0b" : "#374151", color: "#fff", border: "none", cursor: "pointer", whiteSpace: "nowrap", }}
                    >
                      {isConfirmed ? "Clear" : "Confirm"}
                    </button>
                  )}

                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '2px dashed #e5e7eb', borderRadius: '16px', backgroundColor: '#ffffff', padding: '40px', minHeight: '340px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📁</div>
            <h4 style={{ color: '#4b5563', margin: '0 0 6px 0', fontSize: '16px', fontWeight: '600' }}>No Active Workspace Stream</h4>
            <p style={{ color: '#9ca3af', margin: '0', fontSize: '14px', textAlign: 'center' }}>Please configure a Messaging Template on the sidebar setup to initialize preview options.</p>
          </div>
        )}
      </div>










      {isConfirmModalOpen && (
        <div className="modal-overlay" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.4)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, padding: '12px' }}>
          <div className="modal-content" style={{ background: '#ffffff', borderRadius: '12px', width: '100%', maxWidth: '420px', maxHeight: '90vh', boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.2)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>





            <div className="status-counter-bar">
              <div className="round-counter-badge">
                {previewSelectedContacts.length}
              </div>
              <div>
                <h4 style={{ margin: '0 0 2px 0', fontSize: '15px', fontWeight: '700', color: '#111827' }}>Ready to Send Message</h4>
                <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                  Total of <strong>{previewSelectedContacts.length}</strong> selected user{previewSelectedContacts.length === 1 ? '' : 's'} queued to receive messages.
                </p>
              </div>
            </div>




            {/* Tight Header */}
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#111827' }}>Campaign Summary</h3>
              <button type="button" onClick={() => setIsConfirmModalOpen(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', padding: '4px' }}>
                <X size={16} />
              </button>
            </div>

            {/* Compact Scrollable Body Container */}
            <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto', flex: 1 }}>

              {/* 1. Template Identity */}
              <div>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4f46e5', letterSpacing: '0.05em', marginBottom: '4px' }}>Template</label>
                <div style={{ padding: '8px 12px', background: '#f9fafb', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '13px', fontWeight: '600', color: '#111827' }}>
                  {selectedTemplateName || "No template configured"}
                </div>
              </div>

              {/* 2. Medium-Sized Media Block */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4f46e5', letterSpacing: '0.05em' }}>
                  Media Preview
                </label>

                <div className="media-preview-box" style={{ position: 'relative', width: '100%', height: '160px', backgroundColor: '#f3f4f6', borderRadius: '6px', border: '1px solid #e5e7eb', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '4px' }}>
                  {(() => {
                    const headerComp = selectedTemplateDetails?.components?.find(c => c.type === 'HEADER');
                    const headerUrl = headerComp?.example?.header_handle?.[0];
                    if (!headerUrl) {
                      return <p style={{ padding: '8px', fontSize: '12px', color: '#6b7280', textAlign: 'center', margin: 0 }}>No Media Configured</p>;
                    }

                    // Check if it's an inline browser Object Blob URL preview
                    const isBlob = headerUrl.startsWith('blob:');

                    // Safely extract format fallback checks
                    let fileExtension = '';
                    if (!isBlob) {
                      fileExtension = headerUrl.split('.').pop().toLowerCase();
                    }

                    // Detect image formats natively
                    const isImage = isBlob
                      ? headerComp.format === 'IMAGE'
                      : ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);

                    // Detect video formats natively
                    const isVideo = isBlob
                      ? headerComp.format === 'VIDEO'
                      : ['mp4', 'webm', 'mov', 'avi'].includes(fileExtension);

                    // Detect documents
                    const isPdf = !isBlob && fileExtension === 'pdf';

                    if (isImage) {
                      return <img src={headerUrl} alt="Header Preview" style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#f9fafb' }} />;
                    } else if (isVideo) {
                      return (
                        <video controls key={headerUrl} style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000000' }}>
                          <source src={headerUrl} type={isBlob ? "video/mp4" : `video/${fileExtension}`} />
                        </video>
                      );
                    } else if (isPdf) {
                      return <iframe src={headerUrl} style={{ width: '100%', height: '100%', border: 'none' }} title="PDF Preview" />;
                    }

                    return <p style={{ padding: '4px', fontSize: '11px', margin: 0 }}>Unsupported Format</p>;
                  })()}

                  {/* Absolute Edit Trigger Overlay */}
                  <div onClick={() => handleEditImageClick(selectedTemplateDetails?.id)} style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(17, 24, 39, 0.6)', color: '#ffffff', cursor: 'pointer', opacity: 0, transition: 'opacity 0.2s ease', fontSize: '12px', fontWeight: '600' }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = '0'}
                  >
                    <FaEdit size={18} style={{ marginBottom: '4px' }} />
                    <span>Update Media</span>
                  </div>
                </div>

                {/* Hidden File Input */}
                <input type="file" ref={fileInputRef} onChange={handleFileChange} accept="image/*,application/pdf,video/*" style={{ display: 'none' }} />
              </div>

              {/* 3. Small Text Area */}
              <div>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4f46e5', letterSpacing: '0.05em', marginBottom: '4px' }}>Message Body</label>
                <div style={{ padding: '10px', background: '#fcfcfd', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '12px', color: '#374151', whiteSpace: 'pre-wrap', lineHeight: '1.4', maxHeight: '80px', overflowY: 'auto' }}>
                  {templateDescriptionText || <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>No description content.</span>}
                </div>
              </div>

              {/* 4. Total Target Indicator */}
              <div style={{ padding: '10px 12px', background: 'rgba(79, 70, 229, 0.04)', borderRadius: '6px', border: `1px solid ${theme.primaryBorder}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>Recipients Selected:</span>
                <span style={{ background: theme.primary, color: '#ffffff', padding: '2px 10px', borderRadius: '9999px', fontSize: '12px', fontWeight: '700' }}>
                  {previewSelectedContacts.length}
                </span>
              </div>

            </div>

            {/* Micro Action Bar */}
            <div style={{ padding: '10px 16px', borderTop: '1px solid #e5e7eb', background: '#f9fafb', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
              <button type="button" onClick={() => setIsConfirmModalOpen(false)} style={{ padding: '8px 14px', background: '#ffffff', color: '#374151', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>Cancel</button>
              <button
                type="button"
                onClick={async () => {
                  await handleResetFlag("confirm");
                  await handleSendGreeting();
                  setIsConfirmModalOpen(false);
                }}
                disabled={isSending || selectedContactIds.length === 0}
                style={{ display: 'inline-flex', alignItems: 'center', justify: 'center', gap: '6px', padding: '8px 14px', borderRadius: '6px', backgroundColor: (isSending || selectedContactIds.length === 0) ? '#d1d5db' : theme.primary, color: theme.primaryForeground, border: 'none', fontSize: '12px', fontWeight: '700', cursor: (isSending || selectedContactIds.length === 0) ? 'not-allowed' : 'pointer', transition: 'all 0.15s ease' }}
              >
                <Send size={12} />
                {isSending ? 'Sending...' : 'Send'}
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default SendMessaging;









